import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AuthService {

    constructor(
        private httpClient: HttpClient
    ) { }

    ResetPassword(email: string) {
        return this.httpClient.post(
            environment.API_URL + '/user/password/forgot?username=' + email,
            {
                responseType: 'text',
                headers: {
                    'Content-Type': 'text/plain'
                }
            },
        );
    }

    UpdatePassword(passwordResetRequestToken: string, password: string) {
        return this.httpClient.put(
            environment.API_URL + '/user/password/reset',
            JSON.stringify(password),
            {
                responseType: 'text',
                params: {
                    token: passwordResetRequestToken
                }
            }
        );
    }
}